import { Alert, Slide, SlideProps, Snackbar } from '@mui/material'
import axios from 'axios'
import { DateTime } from 'luxon'
import React, { useEffect, useState } from 'react'
import { IconType } from 'react-icons'
import { BiTrash } from 'react-icons/bi'
import { CgOptions } from 'react-icons/cg'
import { FaUsers } from 'react-icons/fa'
import { HiOutlineIdentification, HiUserCircle } from 'react-icons/hi'
import { IoAddOutline } from 'react-icons/io5'
import { MdOutlineContacts, MdPassword } from 'react-icons/md'
import { RiBillLine, RiEditBoxFill, RiPercentFill } from 'react-icons/ri'
import { useDispatch, useSelector } from 'react-redux'
import { v4 as uuidv4 } from 'uuid'
import EmptyUsers from '../../assets/animations/EmptyUsers.json'
import Empty from '../../components/Display/Empty'
import Modal from '../../components/Display/Modal'
import ModalConfirm from '../../components/Display/ModalConfirm'
import Button from '../../components/General/Button'
import useSnackBars from '../../hooks/SnackbarConsumerHook'
import { changeUserSubscriptionData } from '../../redux/actions/authentication'
import { RootState } from '../../redux/store'
import { AuthService } from '../../services/AuthService'
import {
  deleteToS3,
  uploadDynamicFile,
  uploadToS3,
} from '../../utils/UploadFile'
import { dateToDB, formatPipe, transformDate } from '../../utils/utils'
import AdjustPriceForm from './AdjustPriceForm'
import C2pForm from './C2pForm'
import CardForm from './CardForm'
import ChangeCurrentUserPassword from './ChangeCurrentUserPassword'
import ChangePasswordTenant from './ChangePasswordTenant'
import DigitalInvoiceForm from './DigitalInvoiceForm'
import InfoAccount from './InfoAccount'
import KYCForm from './KYCForm'
import OtherConfigurationForm from './OtherConfigurationForm'
import PagoMovilForm from './PagoMovilForm'
import SubscriptionForm from './SubscriptionForm'
import UserForm from './UserForm'
import UserFormEdit from './UserFormEdit'

const server = process.env.REACT_APP_SERVER_URL
type TransitionProps = Omit<SlideProps, 'direction'>

let authService = new AuthService()

const invoiceMethodOptions = {
  thermal_printer: 'Impresora fiscal',
  free_form: 'Forma libre',
  digital: 'Digital',
}

const Configuration = () => {
  const { addAlert } = useSnackBars()

  const [valuesForm, setvaluesForm] = useState<any>(null)

  const [showConfirmationModal, setShowConfirmationModal] =
    useState<boolean>(false)

  // const [showConfirmModal, setShowConfirmModal] = useState<boolean>(false)

  const [values, setValues] = useState<any | null>(null)

  const [tenantInfo, setTenantInfo] = useState<any>(null)

  const [showSuscripcion, setShowSuscripcion] = useState<boolean>(false)

  const [showC2p, setShowC2p] = useState<boolean>(false)

  const [showPagoMovil, setShowPagoMovil] = useState<boolean>(false)

  const [showCard, setShowCard] = useState<boolean>(false)

  const [amountForPayment, setAmountForPayment] = useState<any>(0)

  const [amountForPaymentRaw, setAmountForPaymentRaw] = useState<number>(0)

  const [isLoading, setIsLoading] = useState<boolean>(false)

  const [isLoadingCancel, setIsLoadingCancel] = useState<boolean>(false)

  const [confirmModal, setconfirmModal] = useState<boolean>(false)

  const [loadingPatching, setLoadingPatching] = useState<boolean>(false)

  const [isKYCLoading, setIsKYCLoading] = useState<boolean>(false)

  /** Funcion que se ejecutara cuando se valide el KYC */
  const [hideKYC, setHideKYC] = useState<boolean>(false)

  const [cardOptions, setCardOptions] = useState<
    { icon: IconType; title: string; subTitle: string }[]
  >([])

  //   const [showInfoAccount, setShowInfoAccount] = useState<boolean>(false)

  const [tenantUser, setTenantUser] = useState<any | null>(null)

  // const [showModalOtherConfiguration, setShowModalOtherConfiguration] = useState<boolean>(false)

  const [rates, setRates] = useState<any>(null)

  const [users, setUsers] = useState<null | any[]>(null)

  const [showCreateUser, setShowCreateUser] = useState<boolean>(false)

  const [showAjustPrice, setShowAjustPrice] = useState<boolean>(false)

  const [showModalChangePassword, setShowModalChangePassword] =
    useState<boolean>(false)

  const [showKYCModal, setshowKYCModal] = useState<boolean>(false)

  const [showDigitalInvoice, setShowDigitalInvoice] = useState<boolean>(false)

  const [digitalInvoiceInfo, setDigitalInvoiceInfo] = useState<any>(null)

  const [isLoadingDigitalInvoice, setIsLoadingDigitalInvoice] =
    useState<boolean>(false)

  const [bodyForm, setBodyForm] = useState<any | null>(null)

  const user = useSelector((state: RootState) => state.auth.user)

  const ratesFromStore = useSelector((state: RootState) => state?.rates?.rates)

  const dispatch = useDispatch()

  const [isLoadingPayment, setIsLoadingPayment] = useState<boolean>(false)

  const [tenant, setTenant] = useState<any | null>(null)

  // Helper function para formatear montos con coma como separador decimal
  const formatAmountWithComma = (amount: number): string => {
    return amount.toFixed(2).replace('.', ',')
  }

  const onClickCard = async (cardTitle: string): Promise<void> => {
    // Usar el título de la card en lugar del índice para evitar problemas cuando se filtran cards

    if (cardTitle === 'Administrar Usuarios') {
      let response = await axios.get(`${server}/user`)
      setUsers(response?.data?.users)
    }

    if (cardTitle === 'Información de cuenta') {
      let response = await axios.get(`${server}/user/tenant`)
      setTenantUser(response.data.tenant)
    }

    if (cardTitle === 'Suscripción') {
      await onGetTenantInfo()
      setShowSuscripcion(true)
    }

    if (cardTitle === 'Otras configuraciones') {
      const today = DateTime.local().setLocale('es')
      let date = `${today.year}-${today.month}-${today.day}`
      let response = await axios.get(
        `${server}/finances/rate?date=${date}&currency=all`
      )
      let tenantInfo = await axios.get(`${server}/config/tenant`)
      setTenantInfo(tenantInfo?.data?.userConf)
      const [usd, eur, cop] = response.data.rates
      setRates({
        usd: usd.rate,
        eur: eur.rate,
        cop: cop.rate,
      })
    }

    if (cardTitle === 'Ajuste de precio masivo') {
      setShowAjustPrice(true)
    }

    if (cardTitle === 'Cambiar contraseña') {
      setShowModalChangePassword(true)
    }

    if (cardTitle === 'KYC') {
      setshowKYCModal(true)
    }

    if (cardTitle === 'Facturación Digital') {
      let response = await axios.get(`${server}/config/tenant`)
      setDigitalInvoiceInfo(response?.data?.userConf)
      setShowDigitalInvoice(true)
    }
  }

  const [transition, setTransition] =
    React.useState<React.ComponentType<TransitionProps> | undefined>(undefined)

  function TransitionDown(props: TransitionProps) {
    return <Slide {...props} direction="down" />
  }

  const [openSnackBar, setOpenSnackBar] = useState<boolean>(false)

  const [invoiceMethod, setInvoiceMethod] = useState<any>(null)

  const onGetTenantInfo = async () => {
    let response = await axios.get(`${server}/user/tenant`)
    setInvoiceMethod(response.data.tenant.invoiceMethod)
    setTenant(response.data.tenant)
  }

  useEffect(() => {
    onGetTenantInfo()
  }, [])

  // Consolidar toda la lógica de cards dinámicas en un solo useEffect
  // Solo ejecutar cuando tenant esté cargado para evitar glitches
  useEffect(() => {
    // No construir cards hasta que tenant esté cargado
    if (!tenant) return

    const baseCards = [
      {
        icon: RiBillLine,
        title: 'Método de facturación',
        subTitle: '',
      },
      {
        icon: FaUsers,
        title: 'Administrar Usuarios',
        subTitle: 'Agrega o elimina compañeros de equipo.',
      },
      {
        icon: RiEditBoxFill,
        title: 'Información de cuenta',
        subTitle: 'Revisa y actualiza la información de tu cuenta.',
      },
      {
        icon: MdOutlineContacts,
        title: 'Suscripción',
        subTitle: 'Escoge tu plan y realiza los pagos.',
      },
      {
        icon: CgOptions,
        title: 'Otras configuraciones',
        subTitle: 'Numeración Factura y otros.',
      },
      {
        icon: RiPercentFill,
        title: 'Ajuste de precio masivo',
        subTitle: 'Ajusta el precio de todos tus productos y servicios.',
      },
      {
        icon: MdPassword,
        title: 'Cambiar contraseña',
        subTitle: 'Modifica tu contraseña.',
      },
    ]

    // Agregar KYC solo si no está validado y no se ha ocultado manualmente
    if (!tenant.isKyc && !hideKYC) {
      baseCards.push({
        icon: HiOutlineIdentification,
        title: 'KYC',
        subTitle: 'Verifica tu identidad.',
      })
    }

    // Agregar Facturación Digital solo para master y si el método de facturación es digital
    if (
      user?.['custom:user_role'] === 'master' &&
      invoiceMethodOptions[invoiceMethod] === 'Digital'
    ) {
      baseCards.push({
        icon: RiBillLine,
        title: 'Facturación Digital',
        subTitle: 'Configura tus credenciales de CG Imprenta Digital.',
      })
    }

    setCardOptions(baseCards)
  }, [user, tenant, hideKYC])

  return (
    <>
      <Snackbar
        TransitionComponent={transition}
        open={openSnackBar}
        autoHideDuration={5000}
        onClose={() => {
          setOpenSnackBar(false)
        }}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert
          onClose={() => {
            setOpenSnackBar(false)
          }}
          severity="warning"
          sx={{ width: '100%' }}
        >
          {
            'Solo puedes realizar pagos máximo 15 días antes del vencimiento de su suscripción'
          }
        </Alert>
      </Snackbar>

      <div className="grid md:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-6 px-1">
        {cardOptions.map((card, idx) => (
          <div
            key={idx}
            style={{
              cursor:
                card.title === 'Método de facturación' ? 'inherit' : 'pointer',
            }}
            className="card 2xl:w-96 w-96 h-36 shadow-lg rounded-lg p-4 mb-5 mr-5 text-xl relative dark:bg-black m-auto"
            onClick={() => {
              if (card.title === 'Método de facturación') {
                return
              }
              onClickCard(card.title)
            }}
          >
            {/* <h1>card...</h1> */}
            <div className="flex">
              <div
                style={{ backgroundColor: '#006AEA33', height: 30, width: 30 }}
                className="flex justify-center items-center"
              >
                <card.icon color="#0033A0" />
              </div>

              <div className="ml-3">
                <label
                  style={{ cursor: 'inherit' }}
                  className="text-base font-medium"
                >
                  {card.title}
                </label>
              </div>
            </div>

            <div
              style={{
                width: '100%',
                height: 2,
                backgroundColor: '#CFCDCD',
                marginTop: 10,
              }}
            ></div>

            {card.title === 'Método de facturación' && (
              <div className="mt-2">
                <label
                  className="text-sm"
                  style={{ color: '#5A5B66', cursor: 'inherit' }}
                >
                  Tipo de facturación: {invoiceMethodOptions[invoiceMethod]}
                </label>
              </div>
            )}

            {card.title !== 'Método de facturación' && (
              <div className="mt-2">
                <label
                  className="text-sm"
                  style={{ color: '#5A5B66', cursor: 'inherit' }}
                >
                  {card.subTitle}
                </label>
              </div>
            )}
          </div>
        ))}

        <Modal
          display={tenantUser !== null}
          onClose={() => setTenantUser(null)}
          // xlClasses="w-2/4"
          xlClasses="w-[800px]"
        >
          <InfoAccount
            isLoading={loadingPatching}
            tenatUser={tenantUser}
            onCancel={() => setTenantUser(null)}
            onSubmit={async (values) => {
              setLoadingPatching(true)

              addAlert({
                message: 'Cargando',
                status: 'loading',
              })
              let s3InfoResponse: { value: any } = { value: {} }
              if (values.image !== tenantUser.image) {
                if (tenantUser.image) {
                  await deleteToS3(tenantUser.image)
                }
                if (values.imageToDelete) {
                  await deleteToS3(values.imageToDelete)
                }
                if (values.image) {
                  await uploadToS3(
                    values.image,
                    s3InfoResponse,
                    undefined,
                    user['custom:tenant_id']
                  )
                }
              }

              try {
                await axios.patch(`${server}/user/tenant`, {
                  ...values,
                  image: s3InfoResponse?.value?.Bucket
                    ? `https://${s3InfoResponse.value.Bucket}.s3.amazonaws.com/${s3InfoResponse.value.Key}`
                    : values.imageToDelete
                    ? ' '
                    : tenantUser?.image,
                })
                addAlert({
                  message: 'Cuenta modificada satisfactoriamente',
                  status: 'success',
                })
                setTenantUser(null)
              } catch (err) {
                addAlert({
                  message: 'Error al modificar cuenta',
                  status: 'error',
                })
              } finally {
                setLoadingPatching(false)
              }
            }}
          >
            <ChangePasswordTenant
              tenantUser={tenantUser}
              onSubmit={async (values) => {
                try {
                  addAlert({
                    message: 'Cargando',
                    status: 'loading',
                  })
                  await authService.forgotPassword(user.email)
                  addAlert({
                    message:
                      'Hemos enviado un correo para cambiar la contraseña',
                    status: 'success',
                  })
                } catch (err) {
                  addAlert({
                    message: 'Error al enviar correo',
                    status: 'error',
                  })
                }
              }}
            />
          </InfoAccount>
        </Modal>

        <Modal
          display={rates}
          onClose={() => setRates(null)}
          xlClasses="w-[650px]"
        >
          <OtherConfigurationForm
            rates={rates}
            tenantInfo={tenantInfo}
            onCancel={() => setRates(null)}
            onSubmit={async (values) => {
              setvaluesForm(values)

              if (values.invoiceCode != tenantInfo?.invoiceCode) {
                setShowConfirmationModal(true)
                return
              }

              // console.log('VALUES...', values)
              const today = DateTime.local().setLocale('es')
              let date = `${today.year}-${today.month}-${today.day}`

              if (values.autoRate) {
                try {
                  addAlert({
                    message: 'Modificando configuraciones',
                    status: 'loading',
                  })

                  await axios.patch(`${server}/config/tenant`, {
                    ...values,
                    autoRate: values?.autoRate + '',
                  })
                  addAlert({
                    message: 'Configuraciones modificadas satisfactoriamente',
                    status: 'success',
                  })

                  setRates(null)
                } catch (err) {
                  addAlert({
                    message: 'Error al modificar configuración',
                    status: 'error',
                  })
                }
              } else {
                try {
                  addAlert({
                    message: 'Modificando configuraciones',
                    status: 'loading',
                  })

                  const promises = [
                    axios.patch(`${server}/config/tenant`, {
                      invoiceCode: values.invoiceCode,
                      autoRate: values.autoRate + '',
                      whatsappGreeting: values.whatsappGreeting,
                      saleEmailMessage: values.saleEmailMessage,
                      c2PClientId: values?.c2PClientId,
                      c2PAccountId: values?.c2PAccountId,
                      zelleAccountId: values?.zelleAccountId,
                      pmAccountId: values?.pmAccountId,
                      pmClientId: values?.pmClientId,
                      posAccountId: values?.posAccountId,
                      invoiceControl: values?.invoiceControl,
                    }),
                  ]

                  if (values?.usd) {
                    promises.push(
                      axios.post(`${server}/finances/rate`, {
                        rate: formatPipe(values.usd, true, 4),
                        currency: { id: 1 },
                        date,
                      })
                    )
                  }

                  if (values?.eur) {
                    promises.push(
                      axios.post(`${server}/finances/rate`, {
                        rate: formatPipe(values.eur, true, 4),
                        currency: { id: 3 },
                        date,
                      })
                    )
                  }

                  if (values?.cop) {
                    promises.push(
                      axios.post(`${server}/finances/rate`, {
                        rate: formatPipe(values.cop, true, 4),
                        currency: { id: 4 },
                        date,
                      })
                    )
                  }

                  await Promise.all(promises)

                  addAlert({
                    message: 'Configuraciones modificadas satisfactoriamente',
                    status: 'success',
                  })

                  setRates(null)
                } catch (err) {
                  addAlert({
                    message: 'Error al modificar configuración',
                    status: 'error',
                  })
                }
              }
            }}
          />
        </Modal>

        <ModalConfirm
          displayConfirmModal={showConfirmationModal}
          onCancel={() => setShowConfirmationModal(false)}
          title={`¿Está seguro que desea cambiar el número de facturación de ${tenantInfo?.invoiceCode} a ${valuesForm?.invoiceCode}? Esta acción es irreversible.`}
          onConfirm={async () => {
            // setShowConfirmationModal(false)
            // setvaluesForm(null)

            const today = DateTime.local().setLocale('es')
            let date = `${today.year}-${today.month}-${today.day}`

            if (valuesForm.autoRate) {
              try {
                addAlert({
                  message: 'Modificando configuraciones',
                  status: 'loading',
                })

                await axios.patch(`${server}/config/tenant`, {
                  ...valuesForm,
                  autoRate: valuesForm?.autoRate + '',
                })
                setShowConfirmationModal(false)

                addAlert({
                  message: 'Configuraciones modificadas satisfactoriamente',
                  status: 'success',
                })

                setRates(null)
              } catch (err) {
                addAlert({
                  message: 'Error al modificar configuración',
                  status: 'error',
                })
              }
            } else {
              try {
                addAlert({
                  message: 'Modificando configuraciones',
                  status: 'loading',
                })

                const promises = [
                  axios.patch(`${server}/config/tenant`, {
                    invoiceCode: valuesForm.invoiceCode,
                    autoRate: valuesForm.autoRate + '',
                    whatsappGreeting: valuesForm.whatsappGreeting,
                    saleEmailMessage: valuesForm.saleEmailMessage,
                    c2PClientId: valuesForm?.c2PClientId,
                    c2PAccountId: valuesForm?.c2PAccountId,
                    zelleAccountId: valuesForm?.zelleAccountId,
                    pmAccountId: valuesForm?.pmAccountId,
                    pmClientId: valuesForm?.pmClientId,
                    posAccountId: valuesForm?.posAccountId,
                    invoiceControl: valuesForm?.invoiceControl,
                  }),
                ]

                if (valuesForm?.usd) {
                  promises.push(
                    axios.post(`${server}/finances/rate`, {
                      rate: formatPipe(valuesForm.usd, true, 4),
                      currency: { id: 1 },
                      date,
                    })
                  )
                }

                if (valuesForm?.eur) {
                  promises.push(
                    axios.post(`${server}/finances/rate`, {
                      rate: formatPipe(valuesForm.eur, true, 4),
                      currency: { id: 3 },
                      date,
                    })
                  )
                }

                if (valuesForm?.cop) {
                  promises.push(
                    axios.post(`${server}/finances/rate`, {
                      rate: formatPipe(valuesForm.cop, true, 4),
                      currency: { id: 4 },
                      date,
                    })
                  )
                }

                await Promise.all(promises)

                setShowConfirmationModal(false)

                addAlert({
                  message: 'Configuraciones modificadas satisfactoriamente',
                  status: 'success',
                })

                setRates(null)
              } catch (err) {
                addAlert({
                  message: 'Error al modificar configuración',
                  status: 'error',
                })
              }
            }
          }}
        />

        <Modal
          display={showSuscripcion}
          onClose={() => setShowSuscripcion(false)}
          xlClasses="w-96"
        >
          <SubscriptionForm
            subscriptionType={user['custom:subscription_type']}
            isLoading={isLoadingPayment}
            name={user['custom:real_name']}
            userPlan={user['custom:user_plan']}
            // subscriptionEnd={transformDate(user['custom:subscription_end'])}
            subscriptionEnd={
              tenant?.subscriptionEnd
                ? transformDate(tenant?.subscriptionEnd)
                : ''
            }
            isLoadingCancel={isLoadingCancel}
            onSubmit={async (values) => {
              const subscriptionDate = new Date(user['custom:subscription_end'])

              const currentDate = new Date()

              const timeDifference =
                ((subscriptionDate as any) - (currentDate as any)) /
                (1000 * 60 * 60 * 24)

              // if (timeDifference > 15) {
              //   setTransition(() => TransitionDown)
              //   setOpenSnackBar(true)
              //   return
              // }

              let body = {
                plan: values?.userPlan,
                period: values?.period,
              }

              setBodyForm(body)

              try {
                // addAlert({
                //   message: 'Cargando',
                //   status: 'loading',
                // })

                setIsLoadingPayment(true)

                let response = await axios.post(
                  `${server}/nevula-payment/bs-price`,
                  body
                )

                // Guardar valor raw (número) y formateado (string)
                setAmountForPaymentRaw(response.data?.total)
                const formattedAmount = formatPipe(
                  response.data?.total + '',
                  false,
                  2
                )
                setAmountForPayment(formattedAmount)

                // addAlert({
                //   message: 'Monto obtenido exitosamente',
                //   status: 'success',
                // })

                if (values?.paymentMethod === 'c2p') {
                  setShowC2p(true)
                }

                if (values?.paymentMethod === 'pagoMovil') {
                  setShowPagoMovil(true)
                }

                if (values?.paymentMethod === 'card') {
                  setShowCard(true)
                }
              } catch (err) {
                addAlert({
                  message: 'Error al generar pago',
                  status: 'error',
                })
              } finally {
                setIsLoadingPayment(false)
              }
            }}
            onCancelSuscription={async () => {
              setconfirmModal(true)
            }}
          />
        </Modal>

        <ModalConfirm
          title="¿Está seguro de cancelar su suscripción?"
          body="*Solo tarjeta internacional"
          displayConfirmModal={confirmModal}
          onCancel={() => setconfirmModal(false)}
          onConfirm={async () => {
            setIsLoadingCancel(true)
            try {
              await axios.post(`${server}/stripe/cancel`)

              addAlert({
                message: 'Suscripción cancelada exitosamente',
                status: 'success',
              })

              setShowSuscripcion(false)
              setconfirmModal(false)
            } catch (err) {
              addAlert({
                message:
                  'No se pudo cancelar la suscripción, por favor comunícate con soporte técnico.',
                status: 'error',
              })
            } finally {
              setIsLoadingCancel(false)
              setconfirmModal(false)
            }
          }}
        ></ModalConfirm>

        <Modal
          display={showC2p}
          onClose={() => setShowC2p(false)}
          xlClasses="w-4/12"
          normalClasses="overflow-visible"
        >
          <C2pForm
            isLoading={isLoading}
            amount={amountForPayment}
            onSubmit={async (values) => {
              setIsLoading(true)

              try {
                addAlert({
                  message: 'Validando pago',
                  status: 'loading',
                })

                let bodyToSubmit: any = {
                  clientId: 'J413060540',
                  bank: values?.bank,
                  payerID: `${values?.document?.documentType}${values?.document?.document}`,
                  prefix: values?.phone?.phoneType,
                  phone: values?.phone?.number,
                  token: values?.token,
                  amount:
                    formatPipe(values?.amount, true, 2, -9999999999999999) + '',
                }

                let response = await axios.post<{
                  message: string
                  ref: string
                }>(`${server}/user-payment/c2p`, bodyToSubmit)

                let body = {
                  amount:
                    formatPipe(values?.amount, true, 2, -9999999999999999) + '',
                  // amount: "1.00",
                  ref: response?.data?.ref,
                  // ref: "344343",
                  // period: user['custom:subscription_type'],
                  // plan: user['custom:user_plan']
                  period: bodyForm?.period,
                  plan: bodyForm?.plan,
                }

                await axios.post(`${server}/nevula-payment/validate`, body)

                let responseUserTenant = await axios.get(
                  `${server}/user/tenant`
                )
                //El subscriptionend llega como toIsoString 2024-12-25T00:00:00.000Z
                const { plan, subscriptionType, subscriptionEnd } =
                  responseUserTenant.data?.tenant

                //Hacer patch del token
                await dispatch(
                  changeUserSubscriptionData(
                    plan,
                    new Date(subscriptionEnd),
                    subscriptionType
                  )
                )

                // let authInstance = new AuthService()

                // await authInstance.changeUserSubscriptionData(plan, new Date(subscriptionEnd), subscriptionType)

                addAlert({
                  message: `Pago validado satisfactoriamente por ${values?.amount}`,
                  status: 'success',
                })

                setShowC2p(false)
                setShowSuscripcion(false)
              } catch (err) {
                addAlert({
                  message: 'Error al validar pago',
                  status: 'error',
                })
              } finally {
                setIsLoading(false)
              }
            }}
          />
        </Modal>

        <Modal
          display={showPagoMovil}
          onClose={() => setShowPagoMovil(false)}
          xlClasses="w-4/12"
          normalClasses="overflow-visible"
        >
          <PagoMovilForm
            disabledInput={process.env.REACT_APP_ENVIRONMENT === 'prod'}
            isLoading={isLoading}
            amount={amountForPayment}
            onSubmit={async (values) => {
              setIsLoading(true)

              const body = {
                period: bodyForm?.period,
                ref: values?.ref,
                amount:
                  formatPipe(values?.amount, true, 2, -9999999999999999) + '',
                paymentDate: dateToDB(values?.paymentDate),
                plan: bodyForm?.plan,
                senderPhoneNumber: `58${values?.phoneCode.slice(1)}${
                  values?.phoneNumber
                }`,
              }

              const bodyBNC = {
                ref: values?.ref,
                amount:
                  formatPipe(values?.amount, true, 2, -9999999999999999) + '',
                paymentDate: dateToDB(values?.paymentDate),
                senderPhoneNumber: `58${values?.phoneCode.slice(1)}${
                  values?.phoneNumber
                }`,
                bankCode: values?.bank,
              }

              //eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJyZWYiOiIyODk3NCIsImFtb3VudCI6IjEwMSIsInBheW1lbnREYXRlIjoiMjAyNS04LTIwIiwic2VuZGVyUGhvbmVOdW1iZXIiOiI1ODQyNDIyMDc1MjQiLCJiYW5rQ29kZSI6IjAxOTEiLCJpYXQiOjE3NTgxNjQ3NDUsImV4cCI6MTc1ODI1MTE0NX0.vB_Fm4ah79n1J-7H0lCeVRdSan1FeTJjCa5bSqzfaCY

              // const token : {WorkingKey: string} = await getJsonFromS3("bnc", "token.json")

              // const resp = await axios.post("https://servicios.bncenlinea.com:16500/api/Position/Validate", {
              //   ClientID: "F500050005",
              //   AccountNumber: "01910095202195016021",
              //   Reference: "160",
              //   Amount: 1.31,
              //   DateMovement: "2024-08-14T00:00:00",
              //   ChildClientID: "",
              //   BranchID: "",
              //   Value: token?.WorkingKey,
              // })

              // return

              try {
                let resp = await axios.post(
                  `${server}/nevula-payment/consult-bnc`,
                  bodyBNC
                )

                if (!resp?.data?.validated) {
                  setIsLoading(false)
                  addAlert({
                    message:
                      'Hubo problemas en el procesamiento del pago, por favor verifique que esté ingresando los datos correctamente',
                    status: 'error',
                    duration: 6000,
                  })
                  return
                }

                addAlert({
                  message: 'Validando pago',
                  status: 'loading',
                })

                let respSecond = await axios.post(
                  `${server}/nevula-payment/validate`,
                  { ...body, paymentToken: resp?.data?.token }
                )

                await axios.post(`${server}/nevula-payment/update-cognito`, {
                  cognitoUpdateToken: respSecond?.data?.cognitoUpdateToken,
                })

                let responseUserTenant = await axios.get(
                  `${server}/user/tenant`
                )
                //El subscriptionend llega como toIsoString 2024-12-25T00:00:00.000Z
                const { plan, subscriptionType, subscriptionEnd } =
                  responseUserTenant.data?.tenant

                //Hacer patch del token
                await dispatch(
                  changeUserSubscriptionData(
                    plan,
                    new Date(subscriptionEnd),
                    subscriptionType
                  )
                )

                // Facturación digital
                try {
                  // 1. Obtener el último número de factura
                  const lastInvoiceResponse = await axios.get(
                    `${server}/nevula-invoice/record`
                  )
                  const lastInvoiceNumber =
                    lastInvoiceResponse?.data?.invoiceNumber || '00000'

                  // 2. Incrementar el número de factura
                  const nextInvoiceNumber = (parseInt(lastInvoiceNumber) + 1)
                    .toString()
                    .padStart(5, '0')

                  // 3. Preparar datos de la factura
                  const tenant = responseUserTenant.data?.tenant
                  const documentType = tenant?.document?.documentType || 'V'
                  const documentNumber = (
                    tenant?.document?.document || ''
                  ).padStart(9, '0')

                  // Calcular subtotal e IVA (16%) - usar el monto raw del backend
                  const totalAmount = amountForPaymentRaw
                  const subTotal = totalAmount / 1.16
                  const iva = totalAmount - subTotal

                  // Obtener tasa USD desde Redux y formatear con coma
                  const usdRateRaw =
                    ratesFromStore?.find((r) => r.id === '1')?.rate || '0'
                  const usdRate = parseFloat(usdRateRaw)
                    .toFixed(2)
                    .replace('.', ',')

                  const invoiceData = {
                    numeroFactura: nextInvoiceNumber,
                    documentoIdentidadCliente: `${documentType}${documentNumber}`,
                    nombreRazonSocialCliente: tenant?.businessSocial || '',
                    correoCliente: tenant?.email || '',
                    direccionCliente: tenant?.address?.address || '',
                    telefonoCliente: `58${values?.phoneCode.slice(1)}${
                      values?.phoneNumber
                    }`,
                    subTotal: formatAmountWithComma(subTotal),
                    iva: formatAmountWithComma(iva),
                    tasa_del_dia: usdRate,
                    cognitoUpdateTokenPayload:
                      respSecond?.data?.cognitoUpdateToken,
                    paymentTokenPayload: resp?.data?.token,
                  }

                  // 4. Generar factura digital
                  const invoiceResponse = await axios.post(
                    `${server}/nevula-invoice`,
                    invoiceData
                  )

                  // 5. Registrar factura en la base de datos
                  const invoiceDate = dateToDB(values?.paymentDate)
                  const planNames = {
                    emprendedor: 'Emprendedor',
                    pyme: 'PYME',
                    corporativo: 'Corporativo',
                  }
                  const subscriptionTypeNames = {
                    MONTHLY: 'Mensual',
                    ANNUAL: 'Anual',
                  }

                  await axios.post(`${server}/nevula-invoice/record`, {
                    invoiceNumber: nextInvoiceNumber,
                    invoiceControl: invoiceResponse?.data?.control_number,
                    paymentMethod: 'pago_movil',
                    emailRecipient: tenant?.email,
                    businessName: tenant?.businessSocial,
                    document: `${documentType}${documentNumber}`,
                    address: tenant?.address?.address,
                    amount: totalAmount,
                    concept: `Suscripción Plan ${planNames[plan] || plan} - ${
                      subscriptionTypeNames[subscriptionType] ||
                      subscriptionType
                    }`,
                    subTotal: subTotal,
                    iva: iva,
                    invoicePdf: invoiceResponse?.data?.pdf,
                    invoiceDate: invoiceDate,
                  })

                  console.log('Factura digital generada exitosamente:', {
                    invoiceNumber: nextInvoiceNumber,
                    controlNumber: invoiceResponse?.data?.control_number,
                  })
                } catch (invoiceError) {
                  console.error(
                    'Error al generar factura digital:',
                    invoiceError
                  )
                  // No bloqueamos el flujo principal si falla la facturación
                }

                addAlert({
                  message: `Pago validado satisfactoriamente por ${values?.amount}`,
                  status: 'success',
                })

                setShowPagoMovil(false)
                setShowSuscripcion(false)
              } catch (err: any) {
                if (err?.response?.status === 400) {
                  addAlert({
                    message: 'Ya existe un pago registrado con esos datos',
                    status: 'error',
                    duration: 6000,
                  })
                  return
                }
                addAlert({
                  message:
                    'Hubo problemas en el procesamiento del pago, por favor verifique que esté ingresando los datos correctamente',
                  status: 'error',
                  duration: 6000,
                })
              } finally {
                setIsLoading(false)
              }
            }}
          />
        </Modal>

        <Modal
          display={showCard}
          onClose={() => setShowCard(false)}
          xlClasses="w-4/12"
          normalClasses="overflow-visible"
        >
          <CardForm
            disabledInput={process.env.REACT_APP_ENVIRONMENT === 'prod'}
            isLoading={isLoading}
            amount={amountForPayment}
            onSubmit={async (values) => {
              setIsLoading(true)

              const paddedDocument = values?.document?.padStart(9, '0')
              values.document = paddedDocument

              const body = {
                transactionIdentifier: uuidv4(),
                amount:
                  formatPipe(values?.amount, true, 2, -9999999999999999) + '',
                idCardType:
                  values?.cardType === 'visa'
                    ? 1
                    : values?.cardType === 'mastercard'
                    ? 2
                    : 3,
                cardNumber: values?.cardNumber,
                dtExpiration: +`${values?.expiryMonth}${values?.expiryYear}`,
                cardHolderName: values?.cardHolder,
                accountType: values?.accountType === 'ahorro' ? 10 : 20,
                cvv: values?.cvc,
                cardPIN: +values?.cardPin,
                cardHolderID: values?.document,
                childClientID: '',
                branchID: '',
                operationId: 1,
              }

              const secondBody = {
                period: bodyForm?.period,
                plan: bodyForm?.plan,
                amount:
                  formatPipe(values?.amount, true, 2, -9999999999999999) + '',
              }

              try {
                let resp = await axios.post(
                  `${server}/nevula-payment/card-transaction`,
                  body
                )

                console.log('LUIS RESP', resp)

                if (!resp?.data?.success) {
                  setIsLoading(false)
                  addAlert({
                    message:
                      'Hubo problemas en el procesamiento del pago, por favor verifique que esté ingresando los datos correctamente',
                    status: 'error',
                    duration: 6000,
                  })
                  return
                }

                addAlert({
                  message: 'Validando pago',
                  status: 'loading',
                })

                let currentDate = new Date()

                let day = currentDate.getDate().toString().padStart(2, '0')
                let month = (currentDate.getMonth() + 1)
                  .toString()
                  .padStart(2, '0')
                let year = currentDate.getFullYear()

                let respSecond = await axios.post(
                  `${server}/nevula-payment/validate`,
                  { ...secondBody, paymentToken: resp?.data?.token }
                )

                await axios.post(`${server}/nevula-payment/update-cognito`, {
                  cognitoUpdateToken: respSecond?.data?.cognitoUpdateToken,
                })

                let responseUserTenant = await axios.get(
                  `${server}/user/tenant`
                )
                //El subscriptionend llega como toIsoString 2024-12-25T00:00:00.000Z
                const { plan, subscriptionType, subscriptionEnd } =
                  responseUserTenant.data?.tenant

                //Hacer patch del token
                await dispatch(
                  changeUserSubscriptionData(
                    plan,
                    new Date(subscriptionEnd),
                    subscriptionType
                  )
                )

                // Facturación digital
                try {
                  // 1. Obtener el último número de factura
                  const lastInvoiceResponse = await axios.get(
                    `${server}/nevula-invoice/record`
                  )
                  const lastInvoiceNumber =
                    lastInvoiceResponse?.data?.invoiceNumber || '00000'

                  // 2. Incrementar el número de factura
                  const nextInvoiceNumber = (parseInt(lastInvoiceNumber) + 1)
                    .toString()
                    .padStart(5, '0')

                  // 3. Preparar datos de la factura
                  const tenant = responseUserTenant.data?.tenant
                  const documentType = tenant?.document?.documentType || 'V'
                  const documentNumber = (
                    tenant?.document?.document || ''
                  ).padStart(9, '0')

                  // Calcular subtotal e IVA (16%) - usar el monto raw del backend
                  const totalAmount = amountForPaymentRaw
                  const subTotal = totalAmount / 1.16
                  const iva = totalAmount - subTotal

                  // Obtener tasa USD desde Redux y formatear con coma
                  const usdRateRaw =
                    ratesFromStore?.find((r) => r.id === '1')?.rate || '0'
                  const usdRate = parseFloat(usdRateRaw)
                    .toFixed(2)
                    .replace('.', ',')

                  const invoiceData = {
                    numeroFactura: nextInvoiceNumber,
                    documentoIdentidadCliente: `${documentType}${documentNumber}`,
                    nombreRazonSocialCliente: tenant?.businessSocial || '',
                    correoCliente: tenant?.email || '',
                    direccionCliente: tenant?.address?.address || '',
                    telefonoCliente: '04120000000',
                    subTotal: formatAmountWithComma(subTotal),
                    iva: formatAmountWithComma(iva),
                    tasa_del_dia: usdRate,
                    cognitoUpdateTokenPayload:
                      respSecond?.data?.cognitoUpdateToken,
                    paymentTokenPayload: resp?.data?.token,
                  }

                  // 4. Generar factura digital
                  const invoiceResponse = await axios.post(
                    `${server}/nevula-invoice`,
                    invoiceData
                  )

                  // 5. Registrar factura en la base de datos
                  const invoiceDate = dateToDB(`${day}/${month}/${year}`)
                  const planNames = {
                    emprendedor: 'Emprendedor',
                    pyme: 'PYME',
                    corporativo: 'Corporativo',
                  }
                  const subscriptionTypeNames = {
                    MONTHLY: 'Mensual',
                    ANNUAL: 'Anual',
                  }

                  await axios.post(`${server}/nevula-invoice/record`, {
                    invoiceNumber: nextInvoiceNumber,
                    invoiceControl: invoiceResponse?.data?.control_number,
                    paymentMethod: 'tarjeta_debito',
                    emailRecipient: tenant?.email,
                    businessName: tenant?.businessSocial,
                    document: `${documentType}${documentNumber}`,
                    address: tenant?.address?.address,
                    amount: totalAmount,
                    concept: `Suscripción Plan ${planNames[plan] || plan} - ${
                      subscriptionTypeNames[subscriptionType] ||
                      subscriptionType
                    }`,
                    subTotal: subTotal,
                    iva: iva,
                    invoicePdf: invoiceResponse?.data?.pdf,
                    invoiceDate: invoiceDate,
                  })

                  console.log('Factura digital generada exitosamente:', {
                    invoiceNumber: nextInvoiceNumber,
                    controlNumber: invoiceResponse?.data?.control_number,
                  })
                } catch (invoiceError) {
                  console.error(
                    'Error al generar factura digital:',
                    invoiceError
                  )
                  // No bloqueamos el flujo principal si falla la facturación
                }

                addAlert({
                  message: `Pago validado satisfactoriamente por ${values?.amount}`,
                  status: 'success',
                })

                setShowCard(false)
                setShowSuscripcion(false)
              } catch (err) {
                console.log('LUIS ERROR', err)
                addAlert({
                  message:
                    'Hubo problemas en el procesamiento del pago, por favor verifique que esté ingresando los datos correctamente',
                  status: 'error',
                  duration: 6000,
                })
              } finally {
                setIsLoading(false)
              }
            }}
          />
        </Modal>

        <Modal
          display={users !== null}
          onClose={() => setUsers(null)}
          xlClasses="w-[650px]"
        >
          <div className="flex justify-between">
            <h2 className="text-primary-900 font-bold dark:text-white mb-5 col-span-12">
              Administrar usuarios
            </h2>

            <Button
              type="primary"
              classes="rounded"
              icon={<IoAddOutline />}
              onClick={() => {
                setShowCreateUser(true)
              }}
            >
              Añadir usuario
            </Button>
          </div>

          <div
          // className={`grid mt-7 mb-10 ${
          //   users && users?.length > 0 ? 'justify-between' : 'justify-center'
          // }`}
          // style={{
          //   gridGap: '4%',
          //   gridTemplateColumns: 'repeat(auto-fit, 350px)',
          // }}
          >
            {users &&
              users?.length > 0 &&
              users?.map((user, idx) => (
                <div
                  style={{
                    height: 300,
                    width: '100%',
                    borderRadius: 5,
                    boxShadow: '0px 3px 4px rgba(83, 83, 83, 0.25)',
                    padding: 26,
                    marginBottom: 30,
                  }}
                  className="relative"
                >
                  <div className="flex justify-between items-center mb-3">
                    <div className="flex items-center">
                      <HiUserCircle className="text-primary mr-2" size={25} />
                      <h2 className="text-primary-900 font-bold dark:text-white col-span-12">
                        Usuario
                      </h2>
                    </div>

                    <BiTrash
                      className="text-primary cursor-pointer"
                      size={20}
                      onClick={async () => {
                        try {
                          addAlert({
                            message: 'Cargando',
                            status: 'loading',
                          })

                          await Promise.all([
                            await axios.delete(
                              `${server}/user?id=${user?.idNevulaUser}`
                            ),
                            await axios.post(`${server}/cognito/delete`, {
                              userId: user?.idNevulaUser,
                            }),
                          ])

                          setUsers((prevState: any) => [
                            ...prevState.filter((v, id) => id !== idx),
                          ])

                          addAlert({
                            message: 'Usuario eliminado satisfactoriamente',
                            status: 'success',
                          })
                        } catch (err) {
                          addAlert({
                            message: 'Error al eliminar usuario',
                            status: 'error',
                          })
                        }
                      }}
                    />
                  </div>

                  <UserFormEdit
                    defaultValues={user}
                    onSubmit={async (values) => {
                      addAlert({
                        message: 'Cargando',
                        status: 'loading',
                      })
                      try {
                        if (
                          user.userRole != values.userRole &&
                          user.enabled != Boolean(values.enabled == 'true')
                        ) {
                          if (values.enabled == 'true') {
                            await Promise.all([
                              await axios.patch(`${server}/user`, {
                                ...values,
                                idNevulaUser: user.idNevulaUser,
                              }),
                              await axios.post(`${server}/cognito/role`, {
                                userId: user.idNevulaUser,
                                role: values.userRole,
                              }),
                              await axios.post(`${server}/cognito/enable`, {
                                userId: user.idNevulaUser,
                              }),
                            ])
                          } else {
                            await Promise.all([
                              await axios.patch(`${server}/user`, {
                                ...values,
                                idNevulaUser: user.idNevulaUser,
                              }),
                              await axios.post(`${server}/cognito/role`, {
                                userId: user.idNevulaUser,
                                role: values.userRole,
                              }),
                              await axios.post(`${server}/cognito/disable`, {
                                userId: user.idNevulaUser,
                              }),
                            ])
                          }
                          let val = [...users]
                          val[idx] = {
                            ...values,
                            idNevulaUser: user.idNevulaUser,
                          }
                          setUsers(val)
                          return
                        }
                        if (user.userRole != values.userRole) {
                          await Promise.all([
                            await axios.patch(`${server}/user`, {
                              ...values,
                              idNevulaUser: user.idNevulaUser,
                            }),
                            await axios.post(`${server}/cognito/role`, {
                              userId: user.idNevulaUser,
                              role: values.userRole,
                            }),
                          ])
                        } else if (
                          user.enabled != Boolean(values.enabled == 'true')
                        ) {
                          if (values.enabled == 'true') {
                            await Promise.all([
                              await axios.patch(`${server}/user`, {
                                ...values,
                                idNevulaUser: user.idNevulaUser,
                              }),
                              await axios.post(`${server}/cognito/enable`, {
                                userId: user.idNevulaUser,
                              }),
                            ])
                          } else {
                            await Promise.all([
                              await axios.patch(`${server}/user`, {
                                ...values,
                                idNevulaUser: user.idNevulaUser,
                              }),
                              await axios.post(`${server}/cognito/disable`, {
                                userId: user.idNevulaUser,
                              }),
                            ])
                          }
                        }
                        let val = [...users]
                        val[idx] = {
                          ...values,
                          idNevulaUser: user.idNevulaUser,
                        }
                        setUsers(val)
                        // let response = await axios.patch(`${server}/user`, {
                        //   ...values,
                        //   idNevulaUser: user.idNevulaUser,
                        // })
                        addAlert({
                          message: 'Usuario modificado satisfactoriamente',
                          status: 'success',
                        })
                      } catch (err) {
                        addAlert({
                          message: 'Error al modificar usuario',
                          status: 'error',
                        })
                      }
                    }}
                  />

                  <div
                    style={{
                      position: 'absolute',
                      bottom: 0,
                      width: '100%',
                      padding: 'inherit',
                      left: 0,
                      right: 0,
                    }}
                  >
                    <div
                      style={{
                        width: '100%',
                        height: 1,
                        backgroundColor: '#0033A0',
                      }}
                    ></div>

                    <div
                      className="flex justify-center mt-2"
                      onClick={async () => {
                        try {
                          addAlert({
                            message: 'Cargando',
                            status: 'loading',
                          })
                          await authService.forgotPassword(user.email)
                          addAlert({
                            message:
                              'Hemos enviado un correo para cambiar la contraseña',
                            status: 'success',
                          })
                        } catch (err) {
                          addAlert({
                            message: 'Error al enviar correo',
                            status: 'error',
                          })
                        }
                      }}
                    >
                      <label
                        className="text-base text-primary cursor-pointer font-medium"
                        // onClick={() => onClickCard(idx)}
                      >
                        Cambiar contraseña
                      </label>
                    </div>
                  </div>
                </div>
              ))}

            {users && users.length === 0 && (
              <Empty
                animationProps={{
                  height: 400,
                  width: 400,
                  animation: EmptyUsers,
                }}
                lottieProps={{ style: { position: 'relative', zIndex: 1 } }}
              >
                <p className="font-semibold max-w-xs text-center relative-top-5 z-10 text-sm text-coolGray-500">
                  Añade usuarios para poderlos visualizar en esta pestaña
                </p>
              </Empty>
            )}

            {/* <div
            style={{
              height: 300,
              width: 350,
              borderRadius: 5,
              boxShadow: '0px 3px 4px rgba(83, 83, 83, 0.25)',
            }}
          ></div> */}

            {/* <div
            style={{
              height: 300,
              width: 350,
              borderRadius: 5,
              boxShadow: '0px 3px 4px rgba(83, 83, 83, 0.25)',
            }}
          ></div> */}

            {/* <div
            style={{
              height: 300,
              width: 350,
              borderRadius: 5,
              boxShadow: '0px 3px 4px rgba(83, 83, 83, 0.25)',
            }}
          ></div> */}

            {/* <div
            style={{
              height: 300,
              width: 350,
              borderRadius: 5,
              boxShadow: '0px 3px 4px rgba(83, 83, 83, 0.25)',
            }}
          ></div> */}

            {/* <div
            style={{
              height: 300,
              width: 350,
              borderRadius: 5,
              boxShadow: '0px 3px 4px rgba(83, 83, 83, 0.25)',
            }}
          ></div> */}
          </div>
        </Modal>

        <Modal
          display={showCreateUser}
          onClose={() => setShowCreateUser(false)}
          xlClasses="w-80"
        >
          <UserForm
            onClose={() => setShowCreateUser(false)}
            onSubmit={async (values) => {
              try {
                addAlert({
                  message: 'Creando usuario',
                  status: 'loading',
                })
                let userResponse = await authService.signUp(
                  values.email,
                  values.password,
                  values.realName,
                  user['custom:tenant_id'],
                  user['custom:user_plan'],
                  false,
                  values.userRole
                )
                const { password, password2, ...rest } = values
                let response = await axios.post(`${server}/user`, {
                  ...rest,
                  idNevulaUser: userResponse?.userSub,
                })
                setUsers((prevState: any) => [
                  ...prevState,
                  {
                    ...rest,
                    idNevulaUser: userResponse?.userSub,
                    enabled: true,
                  },
                ])
                addAlert({
                  message: 'Usuario creado satisfactoriamente',
                  status: 'success',
                })
                setShowCreateUser(false)
              } catch (err: any) {
                if (err?.name === 'InvalidPasswordException') {
                  addAlert({
                    message:
                      'La contraseña es inválida, debe de tener al menos 8 caracteres, una mayúscula, una minúscula, un número y un caracter especial',
                    status: 'error',
                  })
                  return
                }

                if (err?.name === 'UsernameExistsException') {
                  addAlert({
                    message: 'Ya existe un usuario con este correo electrónico',
                    status: 'error',
                  })
                  return
                }

                if (
                  err?.response?.data?.message ===
                  'You have reached your user quota limit'
                ) {
                  addAlert({
                    message:
                      'Has llegado al número máximo de usuarios permitidos en este plan',
                    status: 'error',
                  })
                  return
                }

                addAlert({
                  message: 'Error al crear usuario',
                  status: 'error',
                })
              }
            }}
          />
        </Modal>

        <Modal
          display={showAjustPrice}
          onClose={() => setShowAjustPrice(false)}
          xlClasses="w-20"
        >
          <AdjustPriceForm
            onCancel={() => {
              setShowAjustPrice(false)
            }}
            onSubmit={(values) => {
              setValues(values)
            }}
          />
        </Modal>

        <ModalConfirm
          title={
            '¿Está seguro que desea modificar masivamente los productos o servicios?'
          }
          displayConfirmModal={!!values}
          onCancel={() => setValues(null)}
          onConfirm={async () => {
            addAlert({
              message: 'Cargando',
              status: 'loading',
            })

            try {
              await axios.post(`${server}/adjust-prices`, {
                ...values,
                percentage: formatPipe(values?.percentage, true),
              })
              addAlert({
                message: 'Ajuste realizado satisfactoriamente',
                status: 'success',
              })
              setValues(null)
              setShowAjustPrice(false)
            } catch (err) {
              addAlert({
                message: 'Error al realizar ajuste masivo',
                status: 'error',
              })
            }
          }}
        />

        <Modal
          xlClasses="xl:w-2/6"
          display={showModalChangePassword}
          onClose={() => setShowModalChangePassword(false)}
        >
          <ChangeCurrentUserPassword
            onSubmit={async (values) => {
              addAlert({
                message: 'Cambiando contraseña',
                status: 'loading',
              })
              try {
                await authService.changePassword(
                  values?.currentPassword,
                  values?.newPassword
                )
                addAlert({
                  message: 'Contraseña cambiada satisfactoriamente',
                  status: 'success',
                })
                setShowModalChangePassword(false)
              } catch (err: any) {
                if (err.code === 'NotAuthorizedException') {
                  addAlert({
                    message: 'Contraseña incorrecta',
                    status: 'error',
                  })
                  return
                }
                addAlert({
                  message: 'Error al cambiar contraseña',
                  status: 'error',
                })
              }
            }}
            onClose={() => setShowModalChangePassword(false)}
          />
        </Modal>

        <Modal
          xlClasses="xl:w-2/6"
          display={showKYCModal}
          onClose={() => setshowKYCModal(false)}
        >
          <KYCForm
            isKYCLoading={isKYCLoading}
            onSubmitKYC={async (image) => {
              if (!image) {
                addAlert({
                  message: 'El documento es requerido',
                  status: 'error',
                })
                return
              }

              try {
                setIsKYCLoading(true)

                await uploadDynamicFile(
                  image,
                  `${user['custom:tenant_id']}/kyc_id.jpeg`,
                  process.env.REACT_APP_S3_URL_DOCS
                )

                let resp = await axios.post(`${server}/kyc`, {})
                if (resp?.data?.is_valid) {
                  const response = await axios.patch(`${server}/user/tenant`, {
                    isKyc: true,
                  })

                  addAlert({
                    message: 'Documento validado satisfactoriamente',
                    status: 'success',
                  })
                  setshowKYCModal(false)
                  setHideKYC(true)
                } else {
                  addAlert({
                    message:
                      'El documento que subiste, no es un documento de identidad válido, debe de ser un RIF o CI vigente',
                    status: 'error',
                    duration: 8000,
                  })
                }
              } catch (error) {
                addAlert({
                  message: 'Error al validar el documento',
                  status: 'error',
                })
              } finally {
                setIsKYCLoading(false)
              }
            }}
          />
        </Modal>

        <Modal
          xlClasses="xl:w-[650px]"
          display={showDigitalInvoice}
          onClose={() => setShowDigitalInvoice(false)}
        >
          <DigitalInvoiceForm
            tenantInfo={digitalInvoiceInfo}
            isLoading={isLoadingDigitalInvoice}
            onCancel={() => setShowDigitalInvoice(false)}
            onSubmit={async (values) => {
              setIsLoadingDigitalInvoice(true)
              try {
                addAlert({
                  message: 'Guardando credenciales',
                  status: 'loading',
                })

                await axios.patch(`${server}/config/tenant`, {
                  digitalInvoiceUsername: values.digitalInvoiceUsername,
                  digitalInvoicePassword: values.digitalInvoicePassword,
                  digitalInvoiceSerie: values.digitalInvoiceSerie,
                })

                addAlert({
                  message: 'Credenciales guardadas satisfactoriamente',
                  status: 'success',
                })

                setShowDigitalInvoice(false)
              } catch (err) {
                addAlert({
                  message: 'Error al guardar credenciales',
                  status: 'error',
                })
              } finally {
                setIsLoadingDigitalInvoice(false)
              }
            }}
          />
        </Modal>
      </div>
    </>
  )
}

export default Configuration
